import type { AxiosError } from 'axios';
import { emitter } from '@/shared/lib/emitter';

declare module '@/shared/lib/emitter/global' {
// eslint-disable-next-line ts/consistent-type-definitions
  interface EmitterEvents {
    'auth:logout': string | undefined;
    'user:logout': boolean;
    'auth:login': boolean;
  }
}

export const logoutHelper = {
  handleUnauthorized(event: AxiosError, method?: string) {
    const urls = ['/applicants/status/stats', '/user-id'];
    const url = event?.config?.url || '';
    if (event?.response?.status === 401) {
      // Тут гифка с I'm so sorry - но иначе при гет запросе будет обновлена страница и данные пропадут
      emitter.emit('auth:logout', urls.includes(url) ? undefined : method);
    }
  },
  handlerUserLogout() {
    emitter.emit('user:logout', true);
  }
};
